import type { BaseQueryApi } from '@reduxjs/toolkit/query';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { savesV2Api } from './savesV2Api';

export const loadSaveWorldSnapshot = async (
  api: BaseQueryApi,
  saveId: string,
  opts?: {
    includeFuturePlantings?: boolean;
    includeInactiveStructuralObjects?: boolean;
  },
) => {
  if (!saveId) {
    throw new Error('saveId is required');
  }

  const arg = opts?.includeFuturePlantings || opts?.includeInactiveStructuralObjects
    ? {
        saveId,
        ...(opts.includeFuturePlantings ? { includeFuturePlantings: true } : {}),
        ...(opts.includeInactiveStructuralObjects ? { includeInactiveStructuralObjects: true } : {}),
      }
    : saveId;

  return api.dispatch(
    savesV2Api.endpoints.getSaveWorld.initiate(arg, { subscribe: false })
  ).unwrap();
};

export const toQueryFnError = (error: unknown): FetchBaseQueryError => {
  if (error && typeof error === 'object' && 'status' in error) {
    return error as FetchBaseQueryError;
  }

  return {
    status: 'CUSTOM_ERROR',
    error: error instanceof Error ? error.message : 'Unknown error',
  };
};
